import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const InhouseShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Inhouse Section"
    sectionKey="Inhouse"
    backRoute="/sections/inhouse"
  />
);

export default InhouseShipmentRequest;
